import React, { useEffect, useState } from "react";
import Navbar from "../sections/common/Navbar";
import "../Styles/propertylisting.css";
import { FiMapPin } from "react-icons/fi";
import { PiBathtubBold } from "react-icons/pi";
import { FaBed } from "react-icons/fa";
import { FaRegCopy } from "react-icons/fa6";
import { FaCar } from "react-icons/fa";
import Footer from "../sections/common/Footer";
import SearchBar from "../sections/common/SearchBar";
import Pagination from "../sections/common/Pagination";
import "../Styles/propertylist.css";
import { MdOutlineBed } from "react-icons/md";
import { MdOutlineBathtub } from "react-icons/md";
import {
  useNavigate,
  useSearchParams,
  useLocation,
  useLoaderData,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchPropertyList } from "../Redux/slice/propertyListSlice";
import { categoryListApi } from "../apis/propertylisting/propertyListApi";

const PropertyListing = () => {
  const navigate = useNavigate();
  const urlLocation = useLocation();
  // const type = urlLocation.pathname.split("/").pop();

  const [searchParams, setSearchParams] = useSearchParams();
  const [selected, setSelected] = useState("card");
  // const [type, setType] = useState(searchParams.get("type") || "")
  const [categoryData, setCategoryData] = useState([]);
  const [keyword, setKeyword] = useState(searchParams.get("keyword") || "");

  const [propertyType, setPropertyType] = useState(searchParams.get("property_type")?.slice(0, searchParams.get("property_type").lastIndexOf("-")) || "");
  const [propertyTypeId, setPropertyTypeId] = useState(
    searchParams.get("property_type")?.split("-")?.pop() || ""
  );
  const [location, setLocation] = useState(searchParams.get("location")?.slice(0, searchParams.get("location").lastIndexOf("-")) || "");
  const [locationId, setLocationId] = useState(
    searchParams.get("location")?.split("-")?.pop() || ""
  );
  const [priceRange, setPriceRange] = useState(searchParams.get("price_range") || "")
  const [bedroom, setBedroom] = useState(searchParams.get("bedroom") || "");
  const [bathroom, setBathroom] = useState(searchParams.get("bathroom") || "");
  const [amenities, setAmenities] = useState(
    searchParams.get("amenities")?.split(",") || []
  );
  const [areaSqft, setAreaSqft] = useState(searchParams.get("area_sqft") || "");
  const [isFeatured, setIsFeatured] = useState(searchParams.get("is_featured") || "");
  const [page, setPage] = useState(parseInt(searchParams.get("page")) || 1)
  const [updatePage, setUpdatePage] = useState(false)
  const [totalItems, setTotalItems] = useState(null)
  const [itemsPerPage, setItemsPerPage] = useState(null)
  const dispatch = useDispatch();
  const items = useSelector((state) => state?.propertyList.data);

  useEffect(() => {
    if (items) {
      setTotalItems(items?.total)
      setItemsPerPage(items?.per_page)
    }
  }, [items])

  useEffect(() => {
    dispatch(
      fetchPropertyList({
        keyword: keyword,
        propertyType: propertyTypeId,
        type: searchParams.get("type") || "",
        location: locationId,
        bedroom: bedroom,
        bathroom: bathroom,
        amenities: amenities,
        area_sqft: areaSqft,
        isFeatured:isFeatured,
        page: page
      })
    );
  }, [dispatch, updatePage]);

  useEffect(() => {
    const fetchCategoryList = async () => {
      const response = await categoryListApi();
      const categoryList = response?.data?.data;
      setCategoryData(categoryList);
    };

    fetchCategoryList();
  }, []);

  const handleSearch = () => {
    if (!propertyType && !location) {
      alert("Select PropertyType or Location");
      return;
    }

    if (searchParams.get("keyword")) {
      keyword ? searchParams.set("keyword", keyword) : searchParams.delete("keyword");
    } else {
      keyword && searchParams.append("keyword", keyword);
    }

    if (searchParams.get("property_type")) {
      propertyType ? searchParams.set("property_type", `${propertyType}-${propertyTypeId}`) : searchParams.delete("property_type");
    } else {
      propertyType && searchParams.append("property_type", `${propertyType}-${propertyTypeId}`);
    }

    if (searchParams.get("location")) {
      location ? searchParams.set("location", `${location}-${locationId}`) : searchParams.delete("location");
    } else {
      location && searchParams.append("location", `${location}-${locationId}`);
    }

    if (searchParams.get("price_range")) {
      priceRange ? searchParams.set("price_range", priceRange) : searchParams.delete("price_range");
    } else {
      priceRange && searchParams.append("price_range", priceRange);
    }

    setSearchParams(searchParams);
    setUpdatePage(!updatePage)
  };

  const handlePrev = () => {
    if (page > 1) {
      setPage(page - 1);
      if (searchParams.get("page")) {
        page && searchParams.set("page", page - 1);
      } else {
        searchParams.append("page", page - 1);
      }
      setSearchParams(searchParams);
      setUpdatePage(!updatePage)
    }
  };

  const handleNext = () => {
    if (page < totalItems) {
      setPage(page + 1);
      if (searchParams.get("page")) {
        page && searchParams.set("page", page + 1);
      } else {
        searchParams.append("page", page + 1);
      }
      setSearchParams(searchParams);
      setUpdatePage(!updatePage)
    }
  };

  const handlePage = (page) => {
    setPage(page);
    if (searchParams.get("page")) {
      page && searchParams.set("page", page);
    } else {
      searchParams.append("page", page);
    }
    setSearchParams(searchParams);
    setUpdatePage(!updatePage)
  }


  return (
    <>
      <Navbar setUpdatePage={setUpdatePage} updatePage={updatePage} />
      <section className="listing-banner">
        <h1>Property Listing</h1>
      </section>
      <section className="container page-location">
        <p>Home / Property Listing</p>
      </section>
      <SearchBar
        selected={selected}
        categoryData={categoryData && categoryData.category}
        locationData={categoryData && categoryData.location}
        setSelected={setSelected}
        keyword={keyword}
        setKeyword={setKeyword}
        propertyTypeId={propertyTypeId}
        setPropertyTypeId={setPropertyTypeId}
        setPropertyType={setPropertyType}
        locationId={locationId}
        setLocationId={setLocationId}
        setLocation={setLocation}
        handleSearch={handleSearch}
        setPriceRange={setPriceRange}
        priceRange={priceRange}
      />
      {selected === "list" ? (
        <section>
          <div className="container">
            <div className="row listing-row pb-4">
              {items ? (
                <>
                  {items?.data?.map((data) => {
                    return (
                      <div key={data.id} className="col-12 p-0">
                        <div className="featured-box listing-box">
                          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-3 listing-bg">
                            <div className="list-box-img-btn">
                              <button className="sale-btn">For Sell</button>
                              <button className="sale-btn featured"></button>
                            </div>
                          </div>
                          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-7 listing-title">
                            <div
                              className="property_listing_title"
                              onClick={() => navigate("/property-details")}
                            >
                              <h3 className="truncate-title" title={data.title}>
                                {data.title}
                              </h3>
                            </div>

                            <h5>Description</h5>
                            <p className="listing-details">
                              {data.description}
                            </p>
                            <div className="d-flex justify-content-between listing-ameneties">
                              <div className="featured-box-details listing-box-details">
                                <p>
                                  <span>
                                    <FaBed />
                                  </span>
                                  Property Type : {data.property_type}
                                </p>
                                <p>
                                  <span>
                                    <PiBathtubBold />
                                  </span>
                                  Spacious life : {data.area_sqft} Sqft
                                </p>
                              </div>
                              <div className="featured-box-details listing-box-details">
                                <p>
                                  <span>
                                    <FaRegCopy />
                                  </span>
                                  No of Bedroom : {data.badroom} Beds
                                </p>
                                <p>
                                  <span>
                                    <FaCar />
                                  </span>
                                  Listed properties : {data.garage_spaces}{" "}
                                  Parking
                                </p>
                              </div>
                              <div className="featured-box-details listing-box-details">
                                <p>
                                  <span>
                                    <FaRegCopy />
                                  </span>
                                  No of Bathroom : {data.bathroom} Baths
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-2 featured-btn listing-bt">
                            <p>
                              <span>
                                <FiMapPin />
                              </span>
                              {data.address}
                            </p>
                            <div>
                              <button
                                onClick={() => navigate("/property-details")}
                              >
                                Book Now
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </>
              ) : (
                <div>
                  <h5 className="text-center">No data found</h5>
                </div>
              )}
            </div>
          </div>
        </section>
      ) : (
        <section className="property-list-main">
          <div className="container">
            <div className="row list-row pb-3">
              {items ? (
                <>
                  {items?.data?.map((data) => {
                    return (
                      <div
                        key={data.id}
                        className="col-sm-12 col-md-6 col-xl-4 mt-3"
                        onClick={() =>
                          navigate(`/property-details/${data.slug}-${data.id}`)
                        }
                      >
                        <div className="property-list-box">
                          <div className="property-list-box-img">
                            <div className="listing-box-img-btn">
                              <button className="sale-btn">For Sell</button>
                              <button className="sale-btn featured">
                                Featured
                              </button>
                            </div>
                          </div>
                          <div className="property_listing_title">
                            <h3 className="truncate-title" title={data.title}>
                              {data.title}
                            </h3>
                            <p className="truncate-title" title={data.address}>
                              <span>
                                <FiMapPin />
                              </span>
                              {data.address}
                            </p>
                          </div>

                          <div className="property-list-details">
                            <p>
                              <span>
                                <MdOutlineBed />
                              </span>
                              {data.badroom} Beds
                            </p>
                            <p>
                              <span>
                                <MdOutlineBathtub />
                              </span>
                              {data.bathroom} Baths
                            </p>
                            <p>
                              <span>
                                <FaRegCopy />
                              </span>
                              {data.area_sqft} Sqft
                            </p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </>
              ) : (
                <div>
                  <h5 className="text-center">No data found</h5>
                </div>
              )}
            </div>
          </div>
        </section>
      )}

      {items && <Pagination totalItems={totalItems} itemsPerPage={itemsPerPage} page={page} setPage={setPage} handlePrev={handlePrev} handleNext={handleNext} handlePage={handlePage} />}
      <Footer />
    </>
  );
};

export default PropertyListing;
